// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    CANNEDCOMMAND_DELETE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    cannedCommandResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* deleteCannedCommand({ payload }) {
    try {

        let QUERY = `
            mutation deleteCannedCommand ($id: Int!) {
                result: deleteCannedCommand (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(cannedCommandResult({ delete: data?.result }))
        } else yield put(cannedCommandResult({ delete: false }))

    } catch (exc) {
        yield put(cannedCommandResult());
        ExceptionManager(
            exc,
            "Manufacturers/.components/cannedCommandsTab/.components/deleteCannedCommand/redux/saga",
            "deleteCannedCommand"
        )
    }
}

function* watchMethods() {
    yield takeEvery(CANNEDCOMMAND_DELETE_REQUEST, deleteCannedCommand);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}